<template>
  <section class="stats-section">
    <article class="container">
      <header>
        <h2>Создаем инновации в сфере<br>покупки и продажи сырья</h2>
      </header>

      <div class="content">
        <article class="left-part">
          <header>Создаем инновации в сфере покупки и продажи сырья</header>

          <p>
            <b>Быстрые сделки</b> — единый стандарт взаимодействия покупателей и поставщиков
            сократит время и затраты на совершение сделок в онлайне.
          </p>

          <p>
            <b>Личный кабинет</b> — управляйте заказами в личном кабинете и контролируйте весь
            процесс.
          </p>

          <p><b>Выбор предложения</b> — по самой низкой конкурентной цене.</p>

          <p>
            <b>Отсрочка платежа</b> — с даты доставки товара на склад покупателя по категориям
            товаров (30, 45, 60 дней).
          </p>

          <footer>
            <ActionButton action="register">
              НАЧАТЬ РАБОТУ на платформе
            </ActionButton>
          </footer>
        </article>

        <article class="right-part">
          <div class="info-item">
            <header>> 22134</header>
            <p>размещенных заказов</p>
          </div>
          <div class="info-item">
            <header>390 тыс</header>
            <p>тонн объем закупок</p>
          </div>
          <div class="info-item">
            <header>17.3 млрд</header>
            <p>рублей объем сделок на платформе</p>
          </div>
          <div class="info-item">
            <header>514</header>
            <p>поставщиков и покупателей</p>
          </div>

          <p>
            <b>Быстрые сделки</b> — единый стандарт взаимодействия покупателей и поставщиков
            сократит время и затраты на совершение сделок в онлайне.
          </p>

          <p>
            <b>Личный кабинет</b> — управляйте заказами в личном кабинете и контролируйте весь
            процесс.
          </p>

          <p><b>Выбор предложения</b> — по самой низкой конкурентной цене.</p>

          <p>
            <b>Отсрочка платежа</b> — с даты доставки товара на склад покупателя по категориям
            товаров (30, 45, 60 дней).
          </p>

          <footer>
            <ActionButton action="register">
              НАЧАТЬ РАБОТУ на платформе
            </ActionButton>
          </footer>
        </article>
      </div>
    </article>
  </section>
</template>

<script>
import ActionButton from '../ActionButton/ActionButton.vue';

export default {
	name: 'SectionStats',
	components: { ActionButton },
};
</script>

<style lang="scss" src="./SectionStats.scss" />
